<template>
  <div class="ax-step-box">
    <div class="step-box">
      <div class="step-top" :class="statusTemp[data.hr_wf_action_description]">
        <div class="status"></div>
        <div class="status-text">
          【{{
            data.hr_wf_action_description === "已提交"
              ? "开始"
              : data.hr_wf_action_description
          }}】
        </div>
      </div>
      <div class="step-content">
        <div class="details">
          <div class="details-l">
            <h6 v-if="data.emplid_to_description">
              {{ data.emplid_to_description }}
              <span v-if="data.hr_wf_action_description !== '已提交'"
                >审批人</span
              >
            </h6>
            <p>{{ data.action_dt_ss || data.trans_dt }}</p>
          </div>
          <div
            class="details-r"
            @click="collapse"
            v-if="
              data.comments && data.comments !== '' && data.comments !== '无'
            "
          >
            {{
              data.hr_wf_action_description === "已提交"
                ? "申请原因"
                : "审批意见"
            }}
            <van-icon :class="active ? 'icon_active' : ''" name="arrow" />
          </div>
        </div>
        <div class="contents" ref="content">
          <!-- 合同续签处理意见 -->
          <p
            v-if="
              data.qh_contract_yes_description &&
                data.qh_contract_yes_description !== '无'
            "
          >
            处理意见： {{ data.qh_contract_yes_description }}
          </p>
          <!-- 转正处理意见 -->
          <p v-if="data.qh_yes_description && data.qh_yes_description !== '无'">
            处理意见： {{ data.qh_yes_description }}
          </p>
          <!-- 审批意见 -->
          <p v-if="data.comments && data.comments !== '无'">
            {{ data.comments }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ax-step",
  props: {
    data: [Object],
  },
  data() {
    return {
      timer: null,
      active: true,
      statusTemp: {
        已提交: "block_agree",
        同意: "block_agree",
        拒绝: "block_reject",
      },
      activeNames: [],
    };
  },
  methods: {
    collapse() {
      this.active = !this.active;
      let height = this.$refs.content.getBoundingClientRect().height;
      if (!!height) {
        this.$refs.content.style.height = height + "px";
        var f = document.body.offsetHeight;
        this.$refs.content.style.height = "0px";
      } else {
        this.$refs.content.style.height = "auto";
        height = this.$refs.content.getBoundingClientRect().height;
        this.$refs.content.style.height = "0";
        var f = document.body.offsetHeight;
        this.$refs.content.style.height = height + "px";
        var _this = this;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          _this.$refs.content.style = null;
        }, 300);
      }
    },
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  },
};
</script>

<style lang="scss" scoped>
.ax-step-box {
  width: 100%;
  &:last-child {
    .step-box {
      border-color: transparent;
    }
  }
  .step-box {
    border-color: transparent;
    .step-top {
      &.block_agree {
        .status {
          background-color: $link-a;
        }
        .status-text {
          color: $link-a;
        }
      }
      &.block_reject {
        .status {
          background-color: $refuse-color;
        }
        .status-text {
          color: $refuse-color;
        }
      }
      &.block_refuse {
        .status {
          background-color: $refuse-color;
        }
        .status-text {
          color: $refuse-color;
        }
      }
    }
  }
  .step-box {
    margin-left: 22px;
    padding-bottom: 11px;
    padding: 0 12px 12px 15px;
    border-left: 1px solid $border-color;
    position: relative;
    border-top: 1px solid #fff;
    .step-top {
      height: 24px;
      .status {
        width: 11px;
        height: 11px;
        background-color: $border-color;
        border-radius: 50%;
        position: absolute;
        left: -6px;
        top: 0;
      }
      .status-text {
        margin-top: -6px;
        font-size: 17px;
        color: $value-color;
        line-height: 24px;
        text-indent: -0.5em;
      }
    }
    .step-content {
      .details {
        display: flex;
        align-items: center;
        padding-top: 8px;
        .details-l {
          flex: 1;
          h6 {
            font-size: 16px;
            color: $value-color;
            font-weight: inherit;
            line-height: 24px;
            span {
              background: rgba(0, 0, 0, 0.04);
              border-radius: 4px;
              font-size: 14px;
              color: $title-color;
              padding: 1px 5px;
              margin-left: 8px;
              font-weight: normal;
            }
          }
          p {
            margin-top: 4px;
            font-size: 14px;
            color: $title-color;
            line-height: 20px;
          }
        }
        .details-r {
          display: flex;
          align-items: center;
          font-size: 17px;
          color: #576b95;
          .van-icon {
            color: $value-color;
            margin-left: 8px;
            font-size: 16px;
            -webkit-transition: -webkit-transform 0.3s
              cubic-bezier(0.86, 0, 0.07, 1);
            transition: -webkit-transform 0.3s cubic-bezier(0.86, 0, 0.07, 1);
            transition: transform 0.3s cubic-bezier(0.86, 0, 0.07, 1);
            transition: transform 0.3s cubic-bezier(0.86, 0, 0.07, 1),
              -webkit-transform 0.3s cubic-bezier(0.86, 0, 0.07, 1);
            &.icon_active {
              transform: rotate(90deg);
            }
          }
        }
      }
      .contents {
        display: block;
        transition: height 0.3s;
        -webkit-transition: height 0.3s;
        overflow: hidden;
        margin: 14px 0 13px;
        p {
          font-size: 15px;
          color: $des-color;
          line-height: 21px;
        }
      }
    }
  }
}
</style>
